import { Component, Input } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ClaimantService, IncidentalAbsence } from '../..';
import { ActivityService } from '../../services/activity.service';
import { SnackbarService, SnackbarType } from 'src/app/shared';
import { emulator } from '../../services/emulator.service';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-absence-delete-dialog',
    template: `
    <app-dialog
      title="Confirmation"
      ariaLabel="Confirmation dialog"
      [showActions]="false"
      [showHeader]="false"
      ariaLabelMessage="Cancel"
      cancelLabel="Cancel"
    >
      <app-dialog-container
        label="Remove Absence"
        class="container"
        [showHeader]="true"
        [headerLevel]="2"
      >
        {{ 'Please confirm to remove this absence.' | translation: translationRequest }}
        <div class="tw-w-full app-pt4">
          <app-action-row class="tw-w-full">
            <app-button right2 autofocus emphasis="High" (click)="onSubmit()"
              >{{ 'Confirm' | translation: translationRequest }}</app-button
            >
            <app-button
              right1
              id="btnCancel"
              (click)="this.dialog.closeAll()"
              emphasis="Low"
              >{{ 'Cancel' | translation: translationRequest }}</app-button
            >
          </app-action-row>
        </div>
      </app-dialog-container>
    </app-dialog>
  `,
    styles: [],
    standalone: false
})
export class AbsenceDeleteDialogComponent {
  @Input()
  dialogRef: MatDialogRef<any>;

  @Input()
  absence: IncidentalAbsence;

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Absences',
    subGroup: 'Absences',
  });

  constructor(
    public dialog: MatDialog,
    private claimantService: ClaimantService,
    private activityService: ActivityService,
    private enumalatorService: emulator,
    private snackbarService: SnackbarService
  ) {}

  async onSubmit() {
    if (this.enumalatorService.showAuditorInfo()) {
      this.dialogRef.close();
      this.snackbarService.show(
        'Preview only mode. Absence was not removed',
        SnackbarType.Info
      );
      return;
    } else {
      await this.claimantService.DeleteAbsence(this.absence.absenceUid);
      this.activityService.absenceDeleted.emit(this.absence.absenceUid);
      this.dialogRef.close();
    }
  }
}
